<template>
  <div id="wrap">
    <div :class="isPc ? 'wrap-web' : 'wrap-phone'" :style="{background: isPc ? 'url(' + bgImg + ') center center no-repeat' : '', 'background-size': 'cover'}">
      <transition name="fade" mode="out-in">
        <router-view :isPc="isPc"></router-view>
      </transition>
    </div>
  </div>
</template>

<script>
  import { changeTitle, checkDevice } from './common/Common.js'
  import AppInfo from '../appInfo/index'
  import { checkVersion } from './common/utils.js'
  export default {
    data () {
      return {
        isPc: Boolean,
        bgImg: AppInfo.getBackgroundImg()
      }
    },
    mounted () {
      this.isPc = checkDevice()
      changeTitle()
      checkVersion()
    }
  }
</script>

<style lang="less" scoped>
	#wrap {
      /* 动画 */
    .fade-enter-active, .fade-leave-active {
      transition: opacity .2s ease;
    }
    .fade-enter, .fade-leave-active {
      opacity: 0;
    }

    .wrap-web {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      background-size: cover;
    }
    .wrap-phone {
      width: 100%;
      height: 100%;
      position: fixed;
    }
  }
</style>



// WEBPACK FOOTER //
// Wrap.vue?f7398020